import services from './../../services/service'; // Service Class
import Preset from './../../mixins/preset.js'; //preset
let service = new services();

export default {
    name: 'CNInsuranceFileComplaint',
    props: {
        cninsurance_listing:Object,
        cninsurance:Object,
    },
    mixins: [Preset],
    data () {
        return {
            user: {},
            // cninsurance_listing:{},
            cninsurance_data:{},
            files_info:[], //muttiple files
            imageForm: "",
            imagesFormArray: [], //multiple files
            max_files_upload: 10,
            remove_files:false,
            data_processing_message: "",
            process_request_sent:false,
        }
    },
    components: {
    },
    computed: {
       
    },
    methods: {
        reset(){
            this.process_request_sent = false; 
            this.data_processing_message = '';
            this.cninsurance_data = {};
            //this.cninsurance.cninsurance_form = {};
        },
       
        prep_sets(){
            this.cninsurance_data.cninsurance_form = this.cninsurance.cninsurance_form;
        },


        submitCNInsuranceForm(){
            var payload={
                form_data_id: this.cninsurance_data.cninsurance_form,
                form_data_title: this.cninsurance_data.cninsurance_complaint_title || "",
                form_data_details: this.cninsurance_data.cninsurance_complaint,
                form_data_type: "cninsurance_file_complaint",
            }
            if((payload.form_data_id != '') && (payload.form_data_title != '') && (payload.form_data_details != '')){
                service.postCNinsuranceFileClaimComplaintForm(this, payload).then(data => {
                    if(data.body.status == 201) {
                        //toastr.success("Processing!", "Success!");
                        if(data.body.data_id > 0){
                            //post pic media
                            if(this.files_info.length > 0){
                                this.onFileChange(data.body.data_id);
                            }else{
                                this.mailCNinsuranceForm(data.body.data_id)
                            }
                            toastr.success("Processing!", "Success!");
                        }else{
                            this.data_processing_message = data.body.message;
                            toastr.error("Form not valid", "Warning!");
                        }
                    }else if(data.body.status == 404) { //invalid form
                        this.data_processing_message = data.body.message;
                        toastr.error("Form not valid", "Warning!");
                    }else {
                        // console.log(err)
                        toastr.error('Sorry, could not process, please check your entries', 'Warning!');
                    }
                }).catch((err) => {
                    if(err) {
                        // console.log(err)
                      toastr.error('Sorry, could not process information, please check your entries', 'Warning!');
                    }
                })
            }else{
                toastr.error('please check your entries', 'Warning!');
            }
        },

        mailCNinsuranceForm(complaint_form_id){
            var payload={
                form_data_id: complaint_form_id,
                form_request_type: 2, //cninsurance_file_complaint
            }
            if((payload.cninsurance_form != '') && (payload.cninsurance_complaint != '')){
                service.mailCNinsuranceFileClaimComplaintForm(this, payload).then(data => {
                    if(data.body.status == 200) {
                        // toastr.success("Processing!", "Success!");
                        this.data_processing_message = "Complaint has been sent";
                        this.process_request_sent = true;
                    }
                }).catch((err) => {
                    if(err) {
                        // console.log(err)
                    //   toastr.error('Sorry, could not process information, please check entries', 'Warning!');
                    }
                })
            }
        },

        setOnFileChange(e, data) {
            let files = e.target.files || e.dataTransfer.files;
            if (files.length){
                for(let file of files){
                    //check cap
                    if(this.files_info.length < this.max_files_upload){
                        this.files_info.push(file);
                    }
                }
            }   
            
        },

         //uploads
         onFileChange(data) {
            let ups_count = 0;
            for(let file of this.files_info){
                let formData = new FormData();
                formData.append('photo', file); 
                formData.append('data_id', data);
                formData.append('data_type', "cninsurance_file_complaint");   
                service.uploadDataPhoto(this, formData).then(response => {
                    ups_count++;
                    if(ups_count == this.files_info.length){
                        //call mail form
                        this.mailCNinsuranceForm(data);
                    }
                    }).catch((err) => {
                })
            }
            
        },

        unsetRemoveFiles(){
            this.remove_files = false;
            //displays sets/resets
            document.getElementById("fileList02").style = "display:block";
            document.getElementById("stackFiles02").style = "display:none";
            //rest
            this.handleFiles();
        },

        setRemoveFiles(){
            this.remove_files = true;
            for (let i = 0; i < this.files_info.length; i++) {
                const li = document.createElement("li");
                // list.appendChild(li);
    
                const img = document.createElement("img");
                img.src = URL.createObjectURL(this.files_info[i]);
                img.height = 40;img.width = 60;
                img.onload = function() {
                    URL.revokeObjectURL(this.src);
                }
                li.appendChild(img);
                let file_ko = document.getElementById("filsdaw"+i);
                file_ko.innerHTML = ""; //reset //for fresh display
                file_ko.appendChild(img);
                //displays sets/resets
                document.getElementById("fileList02").style = "display:none";
                document.getElementById("stackFiles02").style = "display:block";
                //
                //console.log(document.getElementById("filsdaw"+i));
            }
        },

        handleFiles() {
            if (!this.files_info.length) {
                fileList02.innerHTML = "<p>No files selected!</p>";
            } else {
                fileList02.innerHTML = "";
                const list = document.createElement("ul");
                fileList02.appendChild(list);
                list.style.margin = "0"; list.style.padding = "0";
                // ul.style.padding = "0"; ul.style.margin = "0";
                for (let i = 0; i < this.files_info.length; i++) {
                    const li = document.createElement("li");
                    list.appendChild(li);
                    li.style.listStyle = "none";
                    li.style.display = "inline";
                    li.style.padding = "5px";
                    li.style.marginLeft = "0";

                    const img = document.createElement("img");
                    img.src = URL.createObjectURL(this.files_info[i]);
                    img.height = 60;
                    img.onload = function() {
                        URL.revokeObjectURL(this.src);
                    }
                    li.appendChild(img);
                    const info = document.createElement("span");
                    info.innerHTML = this.files_info[i].name + ": " + this.files_info[i].size + " bytes";
                    // li.appendChild(info);
                    const col = document.createElement("span");
                    col.innerHTML='<div>Text</div>';
                    // li.appendChild(col);
                }
                //displays sets/resets
                document.getElementById("fileList02").style = "display:block";
                document.getElementById("stackFiles02").style = "display:none";
                this.remove_files = false; //reset
            }
        },

        
        removeFileUploadXX(file_index){
            // var i = this.files_info.indexOf(file);
           this.files_info.splice(file_index, 1); 
           this.setRemoveFiles();
        },

        removeFileUpload(file){
            let files_info = this.files_info;
            this.files_info = [];
            var index = files_info.indexOf(file);
            while (index > -1) {
                files_info.splice(index, 1);
                index = files_info.indexOf(file);
            }
            this.files_info = files_info;
            this.setRemoveFiles();
        },

        
    },
    mounted: function(){
        // const fileSelect = document.getElementById("fileSelect");
        // let fileElem02 = document.getElementById("fileElem02");

        // fileSelect.addEventListener("click", function (e) {
        // if (fileElem02) {
        //     fileElem02.click();
        // }
        // }, false);

        const fileSelect = document.getElementById("fileSelect");
        let fileElem02 = document.getElementById("fileElem02");
        let fileList02 = document.getElementById("fileList02");

        fileSelect.addEventListener("click", function (e) {
        if (fileElem02) {
            fileElem02.click();
        }
        e.preventDefault(); // prevent navigation to "#"
        }, false);

        fileElem02.addEventListener("change", this.handleFiles, false);

    },
    created: function(){
        this.prep_sets();
        let u_t = localStorage.getItem("cityneeds_token");
        if((u_t != null)) {
            this.preset();
        }else{
            localStorage.setItem("cn_prv_page","cninsurance");//log current page
        }
    }
}


// WEBPACK FOOTER //
// ./src/templates/CNinsuranceFileComplaint/script.js